export let LAYOUT_STYLE_VALUES;
(function (LAYOUT_STYLE_VALUES) {
  LAYOUT_STYLE_VALUES[LAYOUT_STYLE_VALUES["SQUARE"] = 1] = "SQUARE";
  LAYOUT_STYLE_VALUES[LAYOUT_STYLE_VALUES["ROUND"] = 2] = "ROUND";
})(LAYOUT_STYLE_VALUES || (LAYOUT_STYLE_VALUES = {}));
//# sourceMappingURL=layout-style-values.js.map